"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const manifest_1 = require("../manifest");
(0, manifest_1.registerSection)({
    type: 'faq',
    label: 'FAQ',
    icon: 'help-circle',
    category: 'content',
    settingsSchema: zod_1.z.object({
        heading: zod_1.z.string().max(160).default('Frequently asked questions'),
    }),
    defaults: () => ({ heading: 'Frequently asked questions' }),
    maxBlocks: 50,
    blockTypes: {
        item: {
            label: 'Q&A',
            icon: 'help-circle',
            settingsSchema: zod_1.z.object({
                question: zod_1.z.string().max(300).default(''),
                answer: zod_1.z.string().max(3000).default(''),
            }),
        },
    },
    fields: [{ name: 'heading', label: 'Heading', control: 'text' }],
    blockFields: {
        item: [
            { name: 'question', label: 'Question', control: 'text' },
            { name: 'answer', label: 'Answer', control: 'textarea' },
        ],
    },
});
//# sourceMappingURL=faq.js.map